import { render, staticRenderFns } from "./AiproxyAccessPanel.vue?vue&type=template&id=71225a94&scoped=true"
import script from "./AiproxyAccessPanel.vue?vue&type=script&lang=js"
export * from "./AiproxyAccessPanel.vue?vue&type=script&lang=js"
import style0 from "./AiproxyAccessPanel.vue?vue&type=style&index=0&id=71225a94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71225a94",
  null
  
)

export default component.exports